import { Injectable } from '@angular/core';
import { CanLoad, Params, Router, UrlSerializer, UrlTree, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { QuproServiceError, QuproServiceErrorType } from '@arpada/arp-lib-common-qupro';
import { Observable } from 'rxjs';
import { PortalProveedorService } from '../services/api.services';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanLoad, CanActivate {

  private static firtsLoading = true;

  constructor(
    private router: Router,
    private location: Location,
    private serializer: UrlSerializer,
    private portalProveedorService: PortalProveedorService,
  ) { }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean  {
    try {
      let resolveFun: (value?: boolean) => void = null;
      let rejectFun: (reason?: any) => void = null;
      const promiseToReturn = new Promise<boolean>((resolve, reject) => {
        resolveFun = resolve;
        rejectFun = reject;
      });
      let lastUrl: string = null;
      let queryParamsVar: Params;
      // Si primera vez que se carga la web
      if (LoginGuard.firtsLoading) {
        // Si la primera ruta que se carga no es el login guardar la ultima URL y redireccionar al loading
        if (this.router.url && this.router.url !== '/login' &&  this.router.url !== 'login') {
          const lastUrlArray = this.location.path().split('?');
          const urlTree: UrlTree = this.serializer.parse(this.location.path());
          lastUrl = lastUrlArray[0];
          if (urlTree.queryParams) {
            queryParamsVar = urlTree.queryParams;
          }
          this.router.navigate(['loading'], { replaceUrl: true });
        }
        LoginGuard.firtsLoading = false;
      }
      this.portalProveedorService.isUserLogin(
        unexpectedError => {
          console.log('unexpectedError: ');
          this.portalProveedorService.logger.error('[LoginGuard] error inexperado obteniendo si el usuario esta logueado', unexpectedError);
          this.router.navigate(['login'], { replaceUrl: true });
          rejectFun(unexpectedError);
        },
        (quproError: QuproServiceError) => {
          console.log('quproError');
          if (!quproError || quproError.type !== QuproServiceErrorType.UNATHORIZED) {
            // Distinto de Unathorized ya que la libreria hace automaticamente el redirect cuando es no autorizado
            this.portalProveedorService.logger.error(
              '[LoginGuard] error quproServiceError obteniendo si el usuario esta logueado', quproError);
            this.router.navigate(['login'], { replaceUrl: true });
          }
          rejectFun(quproError);
        }
      ).then(
        (result: boolean) => {
          if (lastUrl && result) {
            this.router.navigate([lastUrl], { replaceUrl: true, queryParams: queryParamsVar }).catch((reason: any) => {
              this.router.navigate(['/'], { replaceUrl: true });
            });
          }
          resolveFun(result);
        }
      );
      return promiseToReturn;
    } catch (error) {
      this.portalProveedorService.logger.error(
        '[LoginGuard] error(Exception) obteniendo si el usuario esta logueado', error);
      this.router.navigate(['login'], { replaceUrl: true });
    }
  }

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.portalProveedorService.isUserLoggedLocal();
  }

}
